<template>
  <div>
    <section v-if="currentLanguage === 'English'" class="nci-shutdown-banner" aria-label="Government Funding Lapse">
      <div class="nci-shutdown-banner__body">
        <h2>Government Funding Lapse</h2>
        <p style="margin: 0">
          Because of a lapse in government funding, the information on this website may not be up to date, transactions
          submitted via the website may not be processed, and the agency may not be able to respond to inquiries until
          appropriations are enacted. The NIH Clinical Center (the research hospital of NIH) is open. For more details
          about its operating status, please visit  <a href="https://cc.nih.gov/">cc.nih.gov</a>. Updates regarding
          government operating status and resumption of normal operations can be found at <a href="https://opm.gov/">OPM.gov</a>. <button class="buttonAsLink" @click="toggleLanguage">{{ languageButtonText }}</button>
        </p>
      </div>
    </section>
    <section v-else class="nci-shutdown-banner" aria-label="La falta de fondos del gobierno federal">
      <div class="nci-shutdown-banner__body">
        <h2>La falta de fondos del gobierno federal</h2>
        <p style="margin: 0">
          Ante la falta de fondos del gobierno, no se actualizará este sitio web y la organización no responderá a
          transacciones ni consultas hasta que se aprueben los fondos. El Centro Clínico de los Institutos Nacionales de
          la Salud (NIH), el hospital de investigación, permanecerá abierto. Consulte <a
            href="https://cc.nih.gov/">cc.nih.gov</a> (en inglés). Infórmese sobre el funcionamiento del gobierno federal
          y el reinicio de las actividades en <a href="https://opm.gov/">OPM.gov</a>. <button class="buttonAsLink" @click="toggleLanguage">{{ languageButtonText }}</button>
        </p>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      currentLanguage: 'English', // Default language is English
    };
	},
	computed: {
		/**
		 * We want to display the Language not currently being displayed
		 * @returns {string} - The language not currently being displayed
		 */
		languageButtonText() {
			return this.currentLanguage === 'English' ? 'Español' : 'English';
		}
	},
  methods: {
    toggleLanguage() {
      // Toggle between English and Spanish
      this.currentLanguage = this.currentLanguage === 'English' ? 'Español' : 'English';
		}
  },
};
</script>

<style>
.buttonAsLink {
    background-color: transparent;
    border: none;
    color: #004488 !important;
    cursor: pointer;
    text-decoration: underline;
    text-align: left;
}

.nci-shutdown-banner {
	background: #bb0e3d;
	padding: 15px;
	text-align:left;
	font-weight:normal;
}

.nci-shutdown-banner__body {
	max-width: 1024px;
	margin: 0 auto;
	color: white;
	font-size: 17px;
	line-height: 1.6;
	position: relative;
	padding: 0 15px 0 40px;
}

.nci-shutdown-banner__body:before {
	content: '';
	display: block;
	position: absolute;
	height: 26px;
	width: 26px;
	top: 0;
	left: 0;
	background: none;
	background-color: #fff;
	-webkit-mask: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJzNC40OCAxMCAxMCAxMCAxMC00LjQ4IDEwLTEwUzE3LjUyIDIgMTIgMnptMSAxNWgtMnYtMmgydjJ6bTAtNGgtMlY3aDJ2NnoiLz48L3N2Zz4=) no-repeat center/contain;
	mask: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJzNC40OCAxMCAxMCAxMCAxMC00LjQ4IDEwLTEwUzE3LjUyIDIgMTIgMnptMSAxNWgtMnYtMmgydjJ6bTAtNGgtMlY3aDJ2NnoiLz48L3N2Zz4=) no-repeat center/contain;
}

.nci-shutdown-banner__body h2 {
	font-size: 18px;
	margin: 0;
}
.nci-shutdown-banner__body a,
.nci-shutdown-banner__body a:visited {
	color: white;
}
</style>
